export default class Impfaktion {

    public impfaktion_id: number | null = null;
    public bezeichnung: string | null = null;
    public gueltig: string | null = 'j';
    public gueltig_extern: string | null = null;
    public gueltig_muw_mitarbeiter: string | null = null;
    public gueltig_muw_mitarbeiter_hcw: string | null = null;
    public gueltig_muw_angehoerige: string | null = null;
    public gueltig_medstudent: string | null = null;
    public gueltig_medstudent_hcw: string | null = null;
    public preis: number | null = null;
    public von: string | null = null;
    public bis: string | null = null;
    public impfstoff_id: number | null = null;
    public preis_mitarbeiter: number | null = null;
    public preis_rektorat: number | null = null;
    public leistung_id: number | null = null;
    public impfstoff_name: string | null = null;
    public impfstoff_bezeichnung: string | null = null;
    public patientengruppen: number[] = [];
    public patientengruppen_alle: string | null = null;
    public leistung_name: string | null = null;

    constructor(data?: Partial<Impfaktion>) {
        Object.assign(this, data);
    }
}
